module.exports = __webpack_public_path__ + "img/4.dfc0a82e.png";